import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import Interior360Item from '../../containers/interior360-item';
import PhotoInfo from '../../containers/photo-info';

const Interior360ItemBlock = props => <Interior360Item {...props} />;
Interior360ItemBlock.displayName = 'Interior360Item';

export default withDynamicComponents({
  componentWhitelist: [
    PhotoInfo,
  ],
  mapInputToOutput: [
    ['photoInfo', 'photoInfo'],
  ],
})(Interior360ItemBlock);



// WEBPACK FOOTER //
// ./src/blocks/interior360-item/index.jsx